import React, { useEffect, useState } from "react"
import "./PRSValidationBadge.scss"
import { Typography } from "antd"

const { Text } = Typography

const PRSValidationBadge = ({ type = "error", num = 0, style = {} }) => {
  const [iconClass, setIconClass] = useState("fas fa-do-not-enter")

  useEffect(() => {
    if (type === "error") setIconClass("fas fa-do-not-enter")
    if (type === "warning") setIconClass("fas fa-exclamation-triangle")
    if (type === "note") setIconClass("fas fa-info-circle")
    if (type === "non-site") setIconClass("fas fa-times-circle")
  }, [type])

  const getColor = (type) => {
    switch (type) {
      case "error":
        return "error-badge"
      case "warning":
        return "warning-badge"
      case "non-site":
        return "non-site-badge"
      default:
        return "default-badge"
    }
  }

  return (
    <div
      className="validation-badge-container"
      style={style}
    >
      <i
        type={type}
        className={`${iconClass} validation-badge-icon ${getColor(type)}`}
      />
      <Text type={type}>
        {num} {type.charAt(0).toUpperCase() + type.slice(1)}(s)
      </Text>
    </div>
  )
}

export default PRSValidationBadge
